(function () {
  'use strict';
  var SELECTORS = '.miniatura-video-uni, .miniatura-video-unico, .uni-video-card';
  var modal, player, source;

  function buildModal() {
    modal = document.createElement('div');
    modal.id = 'uniVideoModalGlobal';
    modal.className = 'uni-modal-bg';
    modal.innerHTML =
      '<span class="uni-modal-close">&times;</span>' +
      '<video class="uni-modal-video" controls playsinline preload="metadata">' +
      '<source src="" type="video/mp4"></video>';
    document.body.appendChild(modal);
    player = modal.querySelector('video');
    source = player.querySelector('source');

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('uni-modal-close')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal(src) {
    if (!src) return;
    source.setAttribute('src', src);
    player.load();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    setTimeout(function () { player.play().catch(function(){}); }, 150);
  }

  function closeModal() {
    player.pause();
    source.removeAttribute('src');
    player.load();
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest(SELECTORS);
    if (!card) return;
    var vid = card.querySelector('source');
    openModal(vid ? vid.getAttribute('src') : '');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildModal);
  } else {
    buildModal();
  }
})();